const data = {
    title: "set wahtever data you have"
}
const eventsVideo = {
    videoHeading: 'Events',
    allVideo: [ 
        {
            videoTitle: "Adding an Event",
            videoDes: "In this tutorial we will show you how to add an event",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "Tkqo0LPe-uk"
        },
        {
            videoTitle: "Create Multiple Events",
            videoDes: "In this tutorial we will show you how to create multiple events",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "VAphOInwOhI"
        },
        {
            videoTitle: "Delete an Event",
            videoDes: "In this tutorial we will show you how to delete an event",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "wvvZt5uEwfY"
        },
        {
            videoTitle: "Edit an Event",
            videoDes: "In this tutorial we will show you how to edit an event",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "L6jZ3Qy-naY"
        },
    ]
}

const toolsVideo = {
    videoHeading: 'Tools',
    allVideo: [ 
        {
            videoTitle: "Managing Your Budget",
            videoDes: "In this tutorial we will show you how to manage your event budget",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "pM9-TUoj_yE"
        },
        {
            videoTitle: "Manage Your To-Do List",
            videoDes: "In this tutorial we will show you how manage your to-do list",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "-cckHAUyyNE"
        },
        {
            videoTitle: "Guest List & RSVP's",
            videoDes: "In this tutorial we show you how to manage your guest list and RSVP’s",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "BXrrNPdhCnY"
        },
    ]
}

const orderVideo = {
    videoHeading: 'Orders & Payments',
    allVideo: [ 
        {
            videoTitle: "Find Suppliers & Products",
            videoDes: "In this tutorial we show you how to find businesses, suppliers, products and services",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "pkOCZpu75UA"
        },
        {
            videoTitle: "Order Products & Services",
            videoDes: "In this tutorial we show you how to manage ordering of products and services",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "XcCaHhu8TjY"
        },
        {
            videoTitle: "Pay Suppliers",
            videoDes: "In this tutorial we show you how to pay a business or supplier",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "FbZmmyPxaqw"
        },
        {
            videoTitle: "Completed Payments",
            videoDes: "In this tutorial we show you how to ensure you have finalised payments to a supplier.",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "WLQVJopHJBw"
        },
    ]
}

export default data
export { eventsVideo, toolsVideo, orderVideo }
